import React from "react";
import SelectInput from "./SelectInput";

const TipoCaixaSelect = React.forwardRef(function TipoCaixaSelect(
  { tiposCaixa = [], placeholder = "Selecione um tipo de caixa", ...props },
  ref
) {
  return (
    <SelectInput ref={ref} {...props}>
      <option value="">{placeholder}</option>
      {tiposCaixa.map((tipo) => (
        <option key={tipo.id} value={tipo.id}>
          {tipo.nome}
        </option>
      ))}
    </SelectInput>
  );
});

export default TipoCaixaSelect;
